import { observer } from 'mobx-react';
import Loader from '../../../components/Loader';
import SetCurrentUser from '../../../CurrentUser/Context/SetCurrentUser';
import { currentUserStore } from '../../../CurrentUser/Store';
import ThemeContext, { currentTheme } from '../../../Themes/ThemeContext';
import RegistrationAuth from '../../RegistrationAuth';
import RegistrationAutoLaunchable from '../RegistrationAutoLaunchable';
import RegistrationEnrollment from '../RegistrationEnrollment';

function RegistrationUserWorkflow() {
  switch (currentUserStore.state.kind) {
    case 'waiting':
    case 'loading':
    case 'logging-out':
      return <Loader delay={0} />;
    case 'anonymous':
    case 'errored':
      return (
        <ThemeContext.Provider value={currentTheme()}>
          <RegistrationAuth />
        </ThemeContext.Provider>
      );
    case 'ready':
    case 'refreshing':
      return (
        <SetCurrentUser currentUserResource={currentUserStore.state.currentUserResource}>
          <RegistrationAutoLaunchable />
          <RegistrationEnrollment />
        </SetCurrentUser>
      );
  }
}

export default observer(RegistrationUserWorkflow);
